import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import PatientSessionProvider from 'infrastructure/providers/patient-session-provider';

const PatientSessionLayout: React.FC = () => {
  const { patientGuid } = useParams<{ patientGuid: string }>();
  return (
    <PatientSessionProvider patientGuid={patientGuid!}>
      <Outlet />
    </PatientSessionProvider>
  );
};

export default PatientSessionLayout;
